import type { PaymentProviderBase } from "../payment-provider-base";

const swishPaymentTypes = [
    "swish_on_device",
    "swish_on_another_device",
] as const;
type SwishPaymentType = typeof swishPaymentTypes[number];
const swishPaymentProvider: PaymentProviderBase<"SWISH", SwishPaymentType> = {
    _type: "SWISH-PAYMENT_PROVIDER",
    name: "SWISH",
    displayName: "Swish",
    paymentTypes: swishPaymentTypes,
};

type SwishPaymentProvider = typeof swishPaymentProvider;

export type { SwishPaymentType, SwishPaymentProvider };
export { swishPaymentTypes, swishPaymentProvider };
